import { match } from 'ts-pattern';
export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'FixingSystem'
        }, (fixingSystem)=>{
            return {
                ...fixingSystem,
                type: 'FixingSystem',
                // Settings these to 0 is fined because they will be calculated in the projection and will be fixed
                leftX: 0,
                leftY: 0,
                leftZ: 0,
                rightX: 0,
                rightY: 0,
                rightZ: 0,
                rightAngle: 0,
                sectionSlope: 0,
                order: 1
            };
        }).with({
            type: 'Handrail'
        }, (handrail)=>{
            return {
                ...handrail,
                type: 'Handrail',
                balustradeLength: 0
            };
        }).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v2.js.map